/* eslint-disable no-console */
// import { takeEvery, call, put, fork, take } from "redux-saga/effects";
import { takeEvery, call, put, fork } from "redux-saga/effects";
import io from "socket.io-client";
import { initializeApp } from "firebase/app";
import { getDatabase, ref, get, child } from "firebase/database";
import { store, history } from "store/store";
import historyHelper from "historyHelper";

import { editAddressStore, initAddressesStore } from "store/actions/knxAddress";
import { knxState, internetState } from "store/actions/systemState";
import { actionSettingsSaveData } from "store/actions/settingsActions";
import {
  initConfigurationStore,
  initConfigurationServer,
} from "store/actions/configurationActions";
import { updateBadgeNotifications, updateNotifications } from "store/actions/notificationsActions";

import {
  actionSocketConnectionType,
  actionOnnaSocketStatus,
  actionServerSocketStatus,
  actionSocketInfo,
  // initSocket,
} from "store/actions/socketActions";
import { saveSchedulesFromServer, updateSchedulesFromServer } from "store/actions/scheduleActions";
// END

import constants from "store/constants";
import { updateAlarmStore } from "store/actions/alarmActions";
import { updateIntercomsStore } from "store/actions/intercomsActions";
import { updateChatStore, addChatMessageStore } from "store/actions/chatActions";
import { saveMacrosFromServer, updateMacrosFromServer } from "store/actions/macroActions";
import { showModal } from "store/actions/modalActions";
import { setTrendData, setTrends, setTrendsHistory } from "store/actions/trendsActions";
import { setCloudApisApartment } from "store/actions/cloudApisActions";

import { updateOnnaDevicesState } from "store/actions/onnaDevicesActions";
import { initBacnetAddressesStore, updateBacnetAddressesStore } from "store/actions/bacnetActions";
import {
  updateMainUser,
  openClientReservationSelector,
  closeClientReservationSelector,
} from "store/actions/mainUserActions";
import { newAlertMessage } from "store/actions/globalAlertActions";
import { getAuth, signOut } from "firebase/auth";
import {
  updateAllServicesStore,
  updateServiceStore,
  removeServicesStore,
  updateAllServicesCategoriesStore,
  updateServiceCategoryStore,
  removeServiceCategoriesStore,
  updateServiceEventsStore,
  updateServiceEventStore,
  removeServiceEventStore,
} from "store/actions/servicesActions";
import {
  updateAllAmenitiesStore,
  updateAmenityStore,
  removeAmenitiesStore,
  updateAmenityEventsStore,
  updateAmenityEventStore,
  removeAmenityEventStore,
} from "store/actions/amenitiesActions";
import {
  updateAllSupportCasesStore,
  updateSupportCaseStore,
  removeSupportCaseStore,
} from "store/actions/supportActions";
import {
  updateClientReservationsStore,
  upsertClientReservationStore,
  removeClientReservationStore,
  // updateClientReservationsByClientIdStore,
} from "store/actions/clientReservationsActions";
import {
  updateClientsStore,
  removeClientStore,
  upsertClientStore,
} from "store/actions/clientsActions";
import { updateThermostatIp, cleanThermostatIpReducer } from "store/actions/thermostatIPActions";
import {
  removeProjectManagerStore,
  upsertProjectManagerStore,
  updateProjectManagersStore,
} from "store/actions/projectManagersActions";

import socketConfig from "./socketConfig";
import appConfig from "../utils/appConfig";

const socketPath = socketConfig();

let socketIoClient;
let socketIoMainUser;

let appStarted = false;

const firebaseApp = initializeApp(appConfig);
const database = getDatabase(firebaseApp);

const {
  GET_ONNA_DEVICES_STATE,
  ADD_ONNA_DEVICE_TO_PROJECT,
  REMOVE_ONNA_DEVICES_FROM_PROJECT,
  CHECK_CAPTCHA,
  ACCESS_CONTROL_CHECK_CREDENTIALS,
  ACCESS_CONTROL_GET_LOCKS,
  ACCESS_CONTROL_GET_LOCK_PASSWORDS,
  ACCESS_CONTROL_REMOVE_LOCK_PASSWORD,
  ACCESS_CONTROL_GET_LOCK_DETAIL,
  ACCESS_CONTROL_LOCK_UNLOCK,
  ACCESS_CONTROL_GET_LOCK_DETAIL_CLIENT,
  ACCESS_CONTROL_LOCK_UNLOCK_CLIENT,
  ACCESS_CONTROL_CREATE_PASSWORD,
  GET_OCCUPANCY_DATA,
  GET_OCCUPANCY_DATA_XLSX,
  MAKE_QUERY,
  SEND_VALUE_SERVER,
  GET_IP_ADDRESS,
  INIT_SOCKET,
  INIT_CLIENT,
  INIT_MAIN_USER_SOCKET,
  SELECT_CLIENT_RESERVATION,
  END_SOCKET,
  INIT_CONFIGURATION_SERVER,
  KNX_STATE_FROM_SERVER,
  INTERNET_STATE_FROM_SERVER,
  SETTINGS_SEND_DATA,
  GET_ALL_CHAT_MESSAGES,
  SEND_CHAT_MESSAGE,
  SEND_CHAT_READ_EVENT,
  DELETE_CHAT_MESSAGE,
  // SEND_DATE_TIME,
  GET_DATE_TIME,
  UPDATE_APP,
  REBOOT_ONNA,
  SEND_CHANGE_OPEN_STATE,
  CREATE_MAIN_USER,
  UPLOAD_MAIN_USER_IMAGE,
  DELETE_MAIN_USER_IMAGE,
  UPLOAD_PROJECT_IMAGE,
  DELETE_PROJECT_IMAGE,
  SEND_REMOVE_USER_LIST,
  SEND_PROTECT_SETTINGS_PAGE,
  ASK_NAVIGATE_PERMISSION,
  SEND_NEW_SCHEDULE_SERVER,
  SEND_EDIT_SCHEDULE_SERVER,
  SEND_REMOVE_SCHEDULE_SERVER,
  SEND_ENABLE_SCHEDULES_SERVER,
  SEND_READ_NOTIFICATION_SERVER,
  SEND_REMOVE_NOTIFICATION_SERVER,
  SEND_ARM_ALARM_SERVER,
  SEND_DISARM_ALARM_SERVER,
  SEND_CHANGE_PASSWORD_ALARM_SERVER,
  SEND_GROUP_ACTION_SERVER,
  SEND_EDIT_ROOM_NAME_SERVER,
  SEND_EDIT_ROOM_COLOR_SERVER,
  SEND_EDIT_DEVICE_NAME_SERVER,
  SEND_BUZZER_CLICK_SERVER,
  SEND_NEW_MACRO_SERVER,
  SEND_EDIT_MACRO_SERVER,
  SEND_REMOVE_MACRO_SERVER,
  SEND_EXECUTE_MACRO_SERVER,
  SEND_NEW_CALL_STATE_SERVER,
  SEND_NEW_VOLUMES_SERVER,
  SEND_TEST_AUDIO_SERVER,
  SEND_NEW_FAVOURITES_SERVER,
  GET_TREND_DATA,
  GET_TREND_DATA_XLSX,
  SET_TRENDS_HISTORY,
  STORE_TREND_HISTORY,
  REMOVE_TREND_DATA,
  CHANGE_THERMOSTATIP_VALUE,
  GET_SERVICE_EVENTS,
  UPDATE_SERVICE_EVENT,
  REMOVE_SERVICE_EVENT,
  GET_ALL_SERVICES,
  UPDATE_SERVICE,
  REMOVE_SERVICES,
  GET_ALL_SERVICE_CATEGORIES,
  UPDATE_SERVICE_CATEGORY,
  REMOVE_SERVICE_CATEGORIES,
  GET_ALL_AMENTIES,
  UPDATE_AMENITY,
  REMOVE_AMENTIES,
  GET_AMENITY_EVENTS,
  UPDATE_AMENITY_EVENT,
  REMOVE_AMENITY_EVENT,
  GET_ALL_SUPPORT_CASES,
  UPDATE_SUPPORT_CASE,
  REMOVE_SUPPORT_CASE,
  UPDATE_CLIENT_RESERVATIONS,
  // UPDATE_CLIENT_RESERVATIONS_BY_CLIENT_ID,
  UPSERT_CLIENT_RESERVATION,
  REMOVE_CLIENT_RESERVATION,
  UPDATE_CLIENTS,
  UPSERT_CLIENT,
  REMOVE_CLIENT,
  UPDATE_MAIN_USER_EMAIL,
  SEND_GET_PROJECT_MANAGERS,
  SEND_ADD_PROJECT_MANAGER,
  SEND_EDIT_PROJECT_MANAGER,
  SEND_REMOVE_PROJECT_MANAGER,
  SEND_METRICS_LIMITS_BY_PROJECT,
} = constants;

// GLOBAL SOCKET

function ioGetValidCredentials(data) {
  return new Promise((resolve, reject) => {
    const { userId } = data;

    socketIoMainUser.emit("GET_VALID_CREDENTIALS", { userId }, (result) => {
      const {
        error,
        message,
        activeReservations,
        onnaId = null,
        projectId = null,
        projectTimeZone = null,
        mainUserId = null,
        apartmentId = null,
        displayName = "",
        isOldReservation = false,
      } = result;
      // console.log("ioGetValidCredentials result", result);
      if (!error) {
        resolve({
          activeReservations,
          onnaId,
          projectId,
          mainUserId,
          apartmentId,
          projectTimeZone,
          displayName,
          isOldReservation,
        });
        return;
      }

      if (error && message === "userHasNoGrant") {
        store.dispatch(
          newAlertMessage({
            type: "error",
            title: "user",
            content: "userHasNoGrant",
          })
        );
        const auth = getAuth();
        signOut(auth);

        reject(new Error("userHasNoGrant"));
        return;
      }
      if (error && message === "userGrantTimeout") {
        store.dispatch(
          newAlertMessage({
            type: "error",
            title: "user",
            content: "userGrantTimeout",
          })
        );
        const auth = getAuth();
        signOut(auth);

        reject(new Error("userGrantTimeout"));
        return;
      }

      reject(new Error(message || "Unknown error"));
    });
  });
}

const ioSendCheckCaptcha = (token) =>
  new Promise((resolve) => {
    const newCaptchaIo = io(`${socketPath}/captcha`, {
      forceNew: false,
    });
    newCaptchaIo.on("connect", () => {
      newCaptchaIo.emit("CHECK_CAPTCHA", token, (result) => {
        if (result) {
          newCaptchaIo.disconnect();
          newCaptchaIo.close();
          resolve(result);
        } else {
          newCaptchaIo.disconnect();
          newCaptchaIo.close();
          resolve();
        }
      });
    });
  });

function* sendCheckCaptcha({ data }) {
  const { token, resolve } = data;
  try {
    const result = yield call(ioSendCheckCaptcha, token);
    resolve(result);
  } catch (error) {
    console.log(error);
  }
}

const ioSendCreateMainUser = (userData) =>
  new Promise((resolve) => {
    const { uid, firstName, lastName, email, company, password1 } = userData;
    if (email && password1 && uid && firstName && lastName && company) {
      const newCaptchaIo = io(`${socketPath}/captcha`, {
        forceNew: false,
      });
      newCaptchaIo.on("connect", () => {
        newCaptchaIo.emit("CREATE_MAIN_USER", userData, (result) => {
          if (result) {
            newCaptchaIo.disconnect();
            newCaptchaIo.close();
            resolve(result);
          } else {
            newCaptchaIo.disconnect();
            newCaptchaIo.close();
            resolve(false);
          }
        });
      });
    } else {
      resolve(false);
    }
  });

function* sendCreateMainUser({ data }) {
  const { cb } = data;
  if (cb) {
    try {
      const response = yield call(ioSendCreateMainUser, data);
      cb(response);
    } catch (error) {
      cb(false);
    }
  }
}

const ioUploadMainUserImage = ({ image, uid }) =>
  new Promise((resolve, reject) => {
    socketIoMainUser.emit("UPLOAD_MAIN_USER_IMAGE", { image, uid }, (result) => {
      if (result) {
        resolve(result);
      } else {
        reject();
      }
    });
  });

function* uploadMainUserImage({ data }) {
  try {
    const { image, cb } = data;
    if (image && cb) {
      const uid = store.getState()?.mainUserReducer?.uid;
      const result = yield call(ioUploadMainUserImage, { image, uid });
      cb(result);
    }
  } catch (error) {
    console.log(error);
  }
}

const ioDeleteMainUserImage = () =>
  new Promise((resolve, reject) => {
    socketIoMainUser.emit("DELETE_MAIN_USER_IMAGE", {}, (result) => {
      if (result) {
        resolve(result);
      } else {
        reject();
      }
    });
  });

function* deleteMainUserImage({ data }) {
  try {
    const { cb } = data;

    if (cb) {
      const result = yield call(ioDeleteMainUserImage);
      cb(result);
    }
  } catch (error) {
    console.log(error);
    if (data?.cb) data?.cb(false);
  }
}

const ioUploadProjectImage = ({ image, uid, projectId }) =>
  new Promise((resolve, reject) => {
    socketIoMainUser.emit("UPLOAD_PROJECT_IMAGE", { image, uid, projectId }, (result) => {
      if (result) {
        resolve(result);
      } else {
        reject();
      }
    });
  });

function* uploadProjectImage({ data }) {
  try {
    const { image, projectId, cb } = data;
    if (image && projectId && cb) {
      const uid = store.getState()?.mainUserReducer?.uid;

      const result = yield call(ioUploadProjectImage, { image, uid, projectId });

      cb(result.imageUid);
    }
  } catch (error) {
    console.log(error);
  }
}

const ioDeleteProjectImage = ({ imageUid, uid, projectId }) =>
  new Promise((resolve, reject) => {
    socketIoMainUser.emit("DELETE_PROJECT_IMAGE", { imageUid, uid, projectId }, (result) => {
      if (result) {
        resolve(result);
      } else {
        reject();
      }
    });
  });

function* deleteProjectImage({ data }) {
  const { imageUid, projectId, cb } = data;

  try {
    if (imageUid && projectId && cb) {
      const uid = store.getState()?.mainUserReducer?.uid;
      const result = yield call(ioDeleteProjectImage, { imageUid, uid, projectId });
      cb(result.imageUid);
    }
  } catch (error) {
    console.log(error);
    cb(false);
  }
}

const ioSendGetOnnaDevicesState = ({ data }) =>
  new Promise((resolve) => {
    socketIoMainUser.emit("GET_ONNA_DEVICES_STATE", data, (onnaDevicesStates) => {
      resolve(onnaDevicesStates);
    });
  });

function* sendGetOnnaDevicesState(data) {
  try {
    const onnaDevicesStates = yield call(ioSendGetOnnaDevicesState, data);
    yield put(updateOnnaDevicesState(onnaDevicesStates));
  } catch (error) {
    console.log(error);
  }
}

const ioSendAddOnnaDeviceToProject = (data) =>
  new Promise((resolve, reject) => {
    socketIoMainUser.emit("ADD_ONNA_DEVICE_TO_PROJECT", data, (response) => {
      if (response === true) {
        resolve();
      } else {
        reject(response);
      }
    });
  });

function* sendAddOnnaDeviceToProject({ data }) {
  const { resolve, reject, userId, onnaId, projectId } = data;
  try {
    yield call(ioSendAddOnnaDeviceToProject, { userId, onnaId, projectId });
    resolve();
  } catch (error) {
    reject(error);
  }
}

const ioSendRemoveOnnaDevicesFromProject = (data) =>
  new Promise((resolve, reject) => {
    socketIoMainUser.emit("REMOVE_ONNA_DEVICES_FROM_PROJECT", data, (response) => {
      if (response) {
        resolve();
      } else {
        reject();
      }
    });
  });

function* sendRemoveOnnaDevicesFromProject({ data }) {
  const { resolve, reject, userId, onnaIds } = data;
  try {
    yield call(ioSendRemoveOnnaDevicesFromProject, { userId, onnaIds });
    resolve();
  } catch (error) {
    reject();
  }
}

const ioSendMetricsLimitsByProject = (data) =>
  new Promise((resolve) => {
    if (!socketIoMainUser) {
      resolve(false);
      return;
    }

    socketIoMainUser.emit("SEND_METRICS_LIMITS_BY_PROJECT", data, (response) => {
      // console.log("ioSendMetricsLimitsByProject response", response);
      resolve(response);
    });
  });

function* sendMetricsLimitsByProject({ data }) {
  try {
    yield call(ioSendMetricsLimitsByProject, data);
  } catch (error) {
    console.log(error);
  }
}

const ioSendAccessControlCheckCredentials = (data) =>
  new Promise((resolve, reject) => {
    socketIoMainUser.emit("ACCESS_CONTROL_CHECK_CREDENTIALS", data, (response) => {
      if (response) {
        resolve(response);
      } else {
        reject();
      }
    });
  });

function* sendAccessControlCheckCredentials({ data }) {
  const { userData, cb } = data;
  try {
    const response = yield call(ioSendAccessControlCheckCredentials, userData);
    cb(response);
  } catch (error) {
    cb(false);
  }
}

const ioSendAccessControlGetLocks = (projectId) =>
  new Promise((resolve, reject) => {
    socketIoMainUser.emit("ACCESS_CONTROL_GET_LOCKS", projectId, (response) => {
      if (response) {
        resolve(response);
      } else {
        reject();
      }
    });
  });

function* sendAccessControlGetLocks({ data }) {
  const { cb, projectId } = data;
  try {
    const response = yield call(ioSendAccessControlGetLocks, projectId);
    cb(response);
  } catch (error) {
    cb(false);
  }
}

const ioSendAccessControlGetLockPassowrds = (data) =>
  new Promise((resolve, reject) => {
    socketIoMainUser.emit("ACCESS_CONTROL_GET_LOCK_PASSWORDS", data, (response) => {
      if (response) {
        resolve(response);
      } else {
        reject();
      }
    });
  });

function* sendAccessControlGetLockPasswords({ data }) {
  const { cb, lockId, projectId } = data;
  try {
    const response = yield call(ioSendAccessControlGetLockPassowrds, { lockId, projectId });
    cb(response);
  } catch (error) {
    cb(false);
  }
}

const ioSendAccessControlCreatePassword = (data) =>
  new Promise((resolve, reject) => {
    socketIoMainUser.emit("ACCESS_CONTROL_CREATE_PASSWORD", data, (response) => {
      if (response) {
        resolve(response);
      } else {
        reject();
      }
    });
  });

function* sendAccessControlCreatePassword({ data }) {
  const { name, password, lockId, startDate, endDate, projectId, cb } = data;
  try {
    const response = yield call(ioSendAccessControlCreatePassword, {
      name,
      password,
      lockId,
      startDate,
      endDate,
      projectId,
    });
    cb(response);
  } catch (error) {
    cb(false);
  }
}

const ioSendAccessControlRemoveLockPassword = (data) =>
  new Promise((resolve, reject) => {
    socketIoMainUser.emit("ACCESS_CONTROL_REMOVE_LOCK_PASSWORD", data, (response) => {
      if (response) {
        resolve(response);
      } else {
        reject();
      }
    });
  });

function* sendAccessControlRemoveLockPassword({ data }) {
  const { cb, lockId, keyboardPwdId, projectId } = data;
  try {
    const response = yield call(ioSendAccessControlRemoveLockPassword, {
      lockId,
      keyboardPwdId,
      projectId,
    });
    cb(response);
  } catch (error) {
    cb(false);
  }
}

const ioSendAccessControlGetLockDetail = (data) =>
  new Promise((resolve, reject) => {
    socketIoMainUser.emit("ACCESS_CONTROL_GET_LOCK_DETAIL", data, (response) => {
      if (response) {
        resolve(response);
      } else {
        reject();
      }
    });
  });

function* sendAccessControlGetLockDetail({ data }) {
  const { cb, lockId, projectId } = data;
  try {
    const response = yield call(ioSendAccessControlGetLockDetail, {
      lockId,
      projectId,
    });
    cb(response);
  } catch (error) {
    cb(false);
  }
}

const ioSendAccessControlLockUnlock = (data) =>
  new Promise((resolve, reject) => {
    socketIoMainUser.emit("ACCESS_CONTROL_LOCK_UNLOCK", data, (response) => {
      if (response) {
        resolve(response);
      } else {
        reject();
      }
    });
  });

function* sendAccessControlLockUnlock({ data }) {
  const { cb, lockId, projectId } = data;
  try {
    const response = yield call(ioSendAccessControlLockUnlock, {
      lockId,
      projectId,
    });
    cb(response);
  } catch (error) {
    cb(false);
  }
}

// CLIENT SOCKET

const ioSendAccessControlGetLockDetailClient = (data) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("ACCESS_CONTROL_GET_LOCK_DETAIL_CLIENT", data, (response) => {
      if (response) {
        resolve(response);
      } else {
        reject();
      }
    });
  });

function* sendAccessControlGetLockDetailClient({ data }) {
  const { cb, lockId, projectId } = data;
  try {
    const response = yield call(ioSendAccessControlGetLockDetailClient, {
      lockId,
      projectId,
    });
    cb(response);
  } catch (error) {
    cb(false);
  }
}

const ioSendAccessControlLockUnlockClient = (data) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("ACCESS_CONTROL_LOCK_UNLOCK_CLIENT", data, (response) => {
      if (response) {
        resolve(response);
      } else {
        reject();
      }
    });
  });

function* sendAccessControlLockUnlockClient({ data }) {
  const { cb, lockId, projectId } = data;
  try {
    const response = yield call(ioSendAccessControlLockUnlockClient, {
      lockId,
      projectId,
    });
    cb(response);
  } catch (error) {
    cb(false);
  }
}

const ioSendGetOccupancyData = (data) =>
  new Promise((resolve, reject) => {
    socketIoMainUser.emit("GET_OCCUPANCY_DATA", data, (response) => {
      if (response) {
        resolve(response);
      } else {
        reject();
      }
    });
  });

function* sendGetOccupancyData({ data }) {
  const { cb, projectId, start, stop } = data;
  try {
    const response = yield call(ioSendGetOccupancyData, {
      projectId,
      start,
      stop,
    });
    cb(response);
  } catch (error) {
    cb([]);
  }
}

const ioSendGetOccupancyDataXlsxServer = (data) =>
  new Promise((resolve, reject) => {
    socketIoMainUser.emit("GET_OCCUPANCY_DATA_XLSX", data, (requestedInfo) => {
      if (requestedInfo) {
        resolve(requestedInfo);
      } else {
        reject();
      }
    });
  });

function* sendGetOccupancyDataXlsxGenerator(request) {
  try {
    const { data } = request;
    const { startDate, endDate, projectId } = data;
    const offset = new Date().getTimezoneOffset();
    let language = "en-gb";
    if (navigator.languages !== undefined) {
      // eslint-disable-next-line prefer-destructuring
      language = navigator.languages[0];
    } else {
      language = navigator.language;
    }
    const response = yield call(ioSendGetOccupancyDataXlsxServer, {
      projectId,
      start: new Date(startDate).toISOString(),
      stop: new Date(endDate).toISOString(),
      offset,
      language,
    });
    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    a.download = `${startDate}_${endDate}_${projectId}.xlsx`;
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.log(error);
  }
}

const ioSendValueServer = (addressToSend) =>
  new Promise((resolve) => {
    socketIoClient.emit("SET_ADDRESS_VALUE_FROM_CLIENT", addressToSend, (success) => {
      resolve(success);
    });
  }).then((success) => success);

function* sendValueServerGenerator({ updates }) {
  try {
    const addressToSend = updates;
    const success = yield call(ioSendValueServer, addressToSend);
    if (success) {
      yield put(editAddressStore(addressToSend)); // COMMENT for test ONE
    }
  } catch (error) {
    console.log(error);
  }
}

/**
 * ONNA Addresses
 */

const buildAdressesArray = (addressesFromServer, valuesFromServer) => {
  const addresses = [];
  if (addressesFromServer && valuesFromServer) {
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const i in addressesFromServer) {
      addresses.push({
        ...addressesFromServer[i],
        ...valuesFromServer[i],
      });
    }
  }
  return addresses;
};

/**
 * ONNA Configuration
 */

const ioInitConfigurationServer = (userData) =>
  new Promise((resolve, reject) => {
    const { userName } = userData;
    socketIoClient.emit(
      `${userName === "cloud" ? "INIT_CONFIGURATION" : "INIT_CONFIGURATION_FROM_CLIENT"}`,
      (data) => {
        if (data) {
          const {
            addressesFromServer,
            bacnetAddressesFromServer,
            valuesFromServer,
            configurationFromServer,
            alarm,
            intercoms,
            schedules,
            notifications,
            macros,
            usersList,
            premiumServices,
            trends,
            favourites,
            cloudApis,
            thermostatIpDevices,
          } = data;
          resolve({
            addressesFromServer,
            bacnetAddressesFromServer,
            valuesFromServer,
            configurationFromServer,
            alarm,
            intercoms,
            schedules,
            notifications,
            macros,
            usersList,
            premiumServices,
            trends,
            favourites,
            cloudApis,
            thermostatIpDevices,
          });
        } else {
          reject();
        }
      }
    );
  }).then((data) => data);

function* initConfigurationServerGenerator(userData) {
  try {
    // Configuration
    const {
      addressesFromServer,
      bacnetAddressesFromServer,
      valuesFromServer,
      configurationFromServer,
      macros,
      trends,
      schedules,
      notifications,
      cloudApis,
      thermostatIpDevices,
    } = yield call(ioInitConfigurationServer, userData);

    if (thermostatIpDevices) {
      store.dispatch(cleanThermostatIpReducer());
      store.dispatch(updateThermostatIp(thermostatIpDevices));
    }

    const { userName } = userData;

    const addressesArray = buildAdressesArray(addressesFromServer, valuesFromServer);

    if (addressesArray.length === 0) {
      yield put(actionOnnaSocketStatus(false));
    } else {
      yield put(initAddressesStore(addressesArray));
      yield put(actionOnnaSocketStatus(true));
    }

    if (configurationFromServer) {
      const { configuration, settings } = configurationFromServer;

      yield put(
        initConfigurationStore(configuration.filter((apartment) => apartment.nodeId !== "home"))
      );
      yield put(actionSettingsSaveData(settings));
    }

    if (trends) yield put(setTrends(trends));
    if (macros) {
      yield put(saveMacrosFromServer(macros));
    }
    if (schedules) yield put(saveSchedulesFromServer(schedules));
    if (userName === "web" && notifications) {
      store.dispatch(updateNotifications(notifications));
      let badgeNumber = 0;
      Object.values(notifications || {}).forEach((notification) => {
        if (!notification.read) badgeNumber += 1;
      });
      store.dispatch(updateBadgeNotifications(badgeNumber));
    }
    if (cloudApis) yield put(setCloudApisApartment(cloudApis));
    if (bacnetAddressesFromServer) {
      yield put(initBacnetAddressesStore(bacnetAddressesFromServer));
    }
  } catch (e) {
    console.log("Init socket error", e);
  }
}

const ioSendKnxStateServer = () =>
  new Promise((resolve) => {
    socketIoClient.emit("KNX_STATE_FROM_CLIENT", (state) => {
      resolve(state);
    });
  });

function* sendKnxStateServerGenerator() {
  const state = yield call(ioSendKnxStateServer);
  yield put(knxState(state));
}

const ioSendGetClientReservations = () =>
  new Promise((resolve) => {
    socketIoMainUser.emit("GET_CLIENT_RESERVATIONS_FROM_CLIENT", {}, (resp) => {
      resolve(resp);
    });
  });

function* sendGetClientReservations() {
  const resp = yield call(ioSendGetClientReservations);

  const { ok, clientReservations } = resp;
  // console.log("sagas respuesta de sendGetClientReservations", { resp });
  if (ok) {
    yield put(updateClientReservationsStore(clientReservations));
  }
}

const ioSendGetClients = () =>
  new Promise((resolve) => {
    socketIoMainUser.emit("GET_CLIENTS_FROM_CLIENT", {}, (resp) => {
      resolve(resp);
    });
  });

function* sendGetClients() {
  const resp = yield call(ioSendGetClients);

  const { ok, clients } = resp;

  // console.log("sagas respuesta de sendGetClients", { resp });

  if (ok) {
    yield put(updateClientsStore(clients));
  }
}

const ioUpsertClient = (clientData) =>
  new Promise((resolve) => {
    socketIoMainUser.emit("UPSERT_CLIENT", clientData, (resp) => resolve(resp));
  });

function* sendUpsertClient({ data }) {
  const { clientData, cb } = data;

  try {
    const resp = yield call(ioUpsertClient, clientData);

    const { ok, client } = resp || {};

    if (cb) {
      cb(resp);
    }

    if (ok && client?.uid) {
      yield put(upsertClientStore(client));
    }
  } catch (error) {
    console.error("Error in sendUpsertClient:", error);

    if (cb) cb({ ok: false, error });
  }
}

const ioRemoveClient = (uid) =>
  new Promise((resolve) => {
    socketIoMainUser.emit("REMOVE_CLIENT", uid, (resp) => resolve(resp));
  });

function* sendRemoveClient({ data }) {
  const { uid, cb } = data;
  try {
    const resp = yield call(ioRemoveClient, uid);

    const { ok, removedId } = resp || {};

    if (cb) {
      cb(resp);
    }

    if (ok) {
      yield put(removeClientStore(removedId));
      yield call(sendGetClientReservations);
    }
  } catch (error) {
    console.error("Error in sendRemoveClient:", error);

    if (cb) {
      cb({
        ok: false,
        error,
      });
    }
  }
}

function* initCalls(clientData) {
  try {
    yield call(initConfigurationServerGenerator, clientData);
    yield call(sendKnxStateServerGenerator);
  } catch (error) {
    console.error("Error in initCalls:", error);
    throw error;
  }
}

function ioSendSettingsData(settingsData) {
  const { data } = settingsData;
  return new Promise((resolve, reject) => {
    socketIoClient.emit("SEND_SETTINGS_DATA_FROM_CLIENT", data, (success) => {
      if (success) {
        resolve();
      } else {
        reject();
      }
    });
  });
}

function* sendSettingsData(settingsData) {
  try {
    yield call(ioSendSettingsData, settingsData);
    yield put(actionSettingsSaveData(settingsData?.data));
  } catch (error) {
    console.log(error);
  }
}

// CHAT
const ioGetAllChatMessagesFromClient = () =>
  new Promise((resolve) => {
    socketIoMainUser.emit("GET_ALL_CHAT_MESSAGES_FROM_CLIENT", (resp) => resolve(resp));
  });

function* getAllChatMessages() {
  try {
    const resp = yield call(ioGetAllChatMessagesFromClient);

    if (resp?.ok) {
      yield put(
        updateChatStore({
          messagesByClientReservation: resp.messages || {},
          apartmentsMetaByClientReservation: resp.meta || {},
          replace: true,
        })
      );
    }
  } catch (error) {
    console.log("Error in getAllChatMessages:", error);
  }
}

function ioSendChatReadEvent(readEventData) {
  const { data } = readEventData;
  return new Promise((resolve) => {
    socketIoMainUser.emit("SEND_CHAT_READ_EVENT_FROM_CLIENT", data, (resp) => {
      resolve(resp);
    });
  });
}

export function* sendChatReadEvent(action) {
  try {
    const resp = yield call(ioSendChatReadEvent, action);

    if (!resp) return;

    const { clientReservationId } = action?.data || {};
    if (!clientReservationId) return;

    yield put(
      updateChatStore({
        apartmentsMetaByClientReservation: {
          [clientReservationId]: {
            lastRead: {
              master: Date.now(),
            },
          },
        },
      })
    );
  } catch (error) {
    console.log(error);
  }
}

function iosendChatMessage(messageData) {
  const { data } = messageData;
  return new Promise((resolve) => {
    socketIoMainUser.emit("SEND_CHAT_MESSAGE_FROM_CLIENT", data, (resp) => {
      resolve(resp);
    });
  });
}

function* sendChatMessage(messageData) {
  try {
    const resp = yield call(iosendChatMessage, messageData);

    const { ok } = resp;

    const { clientReservationId, message } = messageData?.data || {};

    if (clientReservationId && message?.id && ok) {
      yield put(addChatMessageStore({ clientReservationId, message }));
    }
  } catch (error) {
    console.log(error);
  }
}

function iosendDeleteChatMessage(messageData) {
  const { data } = messageData;

  return new Promise((resolve) => {
    socketIoMainUser.emit("DELETE_CHAT_MESSAGE_FROM_CLIENT", data, (resp) => {
      resolve(resp);
    });
  });
}

function* deleteChatMessage({ data }) {
  try {
    const resp = yield call(iosendDeleteChatMessage, { data });

    const { ok, message, clientReservationId } = resp;

    if (ok && clientReservationId) {
      yield put(addChatMessageStore({ clientReservationId, message }));
    }
  } catch (error) {
    console.log(error);
  }
}

// SERVICES
function ioSendGetServices() {
  return new Promise((resolve) => {
    socketIoMainUser.emit("GET_SERVICES_FROM_CLIENT", (resp) => {
      resolve(resp);
    });
  });
}

function* sendGetServices() {
  try {
    const { ok, services } = yield call(ioSendGetServices);

    if (ok) yield put(updateAllServicesStore(services));
  } catch (error) {
    console.log(error);
  }
}

function ioSendUpdateService(data) {
  return new Promise((resolve) => {
    socketIoMainUser.emit("UPDATE_SERVICE_FROM_CLIENT", data, (resp) => {
      resolve(resp);
    });
  });
}

function* sendUpdateService({ data }) {
  try {
    const { ok, serviceData } = yield call(ioSendUpdateService, data);

    if (ok) {
      yield put(updateServiceStore(serviceData));
    }
  } catch (error) {
    console.log(error);
  }
}

function ioSendRemoveServices(data) {
  return new Promise((resolve) => {
    socketIoMainUser.emit("REMOVE_SERVICES_FROM_CLIENT", data, (resp) => {
      resolve(resp);
    });
  });
}

function* sendRemoveServices({ data }) {
  try {
    const { ok, removedIds } = yield call(ioSendRemoveServices, data);

    if (ok) {
      yield put(removeServicesStore(removedIds));
    }
  } catch (error) {
    console.log(error);
  }
}

// SERVICES CATEGORIES
function ioSendGetServicesCategories() {
  return new Promise((resolve) => {
    socketIoMainUser.emit("GET_SERVICE_CATEGORIES_FROM_CLIENT", (resp) => {
      resolve(resp);
    });
  });
}

function* sendGetServiceCategories() {
  try {
    const { ok, servicesCategories } = yield call(ioSendGetServicesCategories);

    if (ok) yield put(updateAllServicesCategoriesStore(servicesCategories));
  } catch (error) {
    console.log(error);
  }
}

function ioSendUpdateServiceCategory(data) {
  return new Promise((resolve) => {
    socketIoMainUser.emit("UPDATE_SERVICE_CATEGORY_FROM_CLIENT", data, (resp) => {
      resolve(resp);
    });
  });
}

function* sendUpdateServiceCategory({ data }) {
  try {
    const { ok, serviceCategoryData } = yield call(ioSendUpdateServiceCategory, data);

    if (ok) {
      yield put(updateServiceCategoryStore(serviceCategoryData));
    }
  } catch (error) {
    console.log(error);
  }
}

function ioSendRemoveServiceCategories(data) {
  return new Promise((resolve) => {
    // console.log("data sending from sagas", { data });
    socketIoMainUser.emit("REMOVE_SERVICE_CATEGORIES_FROM_CLIENT", data, (resp) => {
      resolve(resp);
    });
  });
}

function* sendRemoveServiceCategories({ data }) {
  try {
    const { ok, removedIds } = yield call(ioSendRemoveServiceCategories, data);
    // console.log({ resp });
    if (ok) {
      yield put(removeServiceCategoriesStore(removedIds));
    }
  } catch (error) {
    console.log(error);
  }
}

// SERVICE EVENTS
function ioSendGetServiceEvents() {
  return new Promise((resolve) => {
    socketIoMainUser.emit("GET_SERVICE_EVENTS_FROM_CLIENT", (resp) => {
      resolve(resp);
    });
  });
}

function* sendGetServiceEvents() {
  try {
    const { ok, serviceEvents } = yield call(ioSendGetServiceEvents);

    // console.log("sagas sendGetServiceEvents", { ok, serviceEvents });

    if (ok) yield put(updateServiceEventsStore(serviceEvents));
  } catch (error) {
    console.log(error);
  }
}

function ioSendUpdateServiceEvent(data) {
  return new Promise((resolve) => {
    socketIoMainUser.emit("UPDATE_SERVICE_EVENT_FROM_CLIENT", data, (resp) => {
      resolve(resp);
    });
  });
}

function* sendUpdateServiceEvent({ data }) {
  const { cb, dataToSend } = data;
  // console.log("sagas sendUpdateServiceEvent", { dataToSend });
  try {
    const response = yield call(ioSendUpdateServiceEvent, dataToSend);
    const { ok, event } = response;
    if (cb) cb(response);

    if (ok) {
      yield put(updateServiceEventStore({ event }));
    }
  } catch (error) {
    if (cb) cb({ ok: false });
    console.log(error);
  }
}

function ioSendRemoveServiceEvent(data) {
  return new Promise((resolve) => {
    socketIoMainUser.emit("REMOVE_SERVICE_EVENT_FROM_CLIENT", data, (resp) => {
      resolve(resp);
    });
  });
}

function* sendRemoveServiceEvent({ data }) {
  try {
    const { dataToSend, cb } = data || {};

    const { ok, eventId, serviceId, clientReservationId } = yield call(
      ioSendRemoveServiceEvent,
      dataToSend
    );

    if (cb) cb({ ok, eventId, serviceId, clientReservationId });

    if (ok) {
      yield put(removeServiceEventStore({ serviceId, eventId, clientReservationId }));
    }
  } catch (error) {
    const { cb } = data || {};
    if (cb) cb({ ok: false });
    console.log(error);
  }
}

// AMENITIES
function ioSendGetAmenities() {
  return new Promise((resolve) => {
    socketIoMainUser.emit("GET_AMENITIES_FROM_CLIENT", (resp) => {
      resolve(resp);
    });
  });
}

function* sendGetAmenities() {
  try {
    const { ok, amenities } = yield call(ioSendGetAmenities);

    if (ok) yield put(updateAllAmenitiesStore(amenities));
  } catch (error) {
    console.log(error);
  }
}

function ioSendUpdateAmenity(data) {
  return new Promise((resolve) => {
    socketIoMainUser.emit("UPDATE_AMENITY_FROM_CLIENT", data, (resp) => {
      resolve(resp);
    });
  });
}

function* sendUpdateAmenity({ data }) {
  try {
    const { ok, amenityData } = yield call(ioSendUpdateAmenity, data);
    // console.log("res sendUpdateAmenity", resp);
    if (ok) {
      yield put(updateAmenityStore(amenityData));
    }
  } catch (error) {
    console.log(error);
  }
}

function ioSendRemoveAmenities(data) {
  return new Promise((resolve) => {
    socketIoMainUser.emit("REMOVE_AMENITIES_FROM_CLIENT", data, (resp) => {
      resolve(resp);
    });
  });
}

function* sendRemoveAmenities({ data }) {
  try {
    const { ok, removedIds } = yield call(ioSendRemoveAmenities, data);

    if (ok) {
      yield put(removeAmenitiesStore(removedIds));
    }
  } catch (error) {
    console.log(error);
  }
}

// AMENITY EVENTS
function ioSendGetAmenityEvents() {
  return new Promise((resolve) => {
    socketIoMainUser.emit("GET_AMENITY_EVENTS_FROM_CLIENT", (resp) => {
      resolve(resp);
    });
  });
}

function* sendGetAmenityEvents() {
  try {
    const { ok, amenityEvents } = yield call(ioSendGetAmenityEvents);

    if (ok) yield put(updateAmenityEventsStore(amenityEvents));
  } catch (error) {
    console.log(error);
  }
}

function ioSendUpdateAmenityEvent(data) {
  return new Promise((resolve) => {
    socketIoMainUser.emit("UPDATE_AMENITY_EVENT_FROM_CLIENT", data, (resp) => {
      resolve(resp);
    });
  });
}

function* sendUpdateAmenityEvent({ data }) {
  const { cb, dataToSend } = data;
  // console.log("sagas sendUpdateAmenityEvent", { dataToSend });
  try {
    const result = yield call(ioSendUpdateAmenityEvent, dataToSend);

    const { ok, event } = result;

    // console.log("sagas sendUpdateAmenityEvent result", { ok });
    if (cb) cb(result);

    if (ok) {
      yield put(
        updateAmenityEventStore({
          event,
        })
      );
    }
  } catch (error) {
    console.log(error);
    if (cb) cb({ ok: false });
  }
}

function ioSendRemoveAmenityEvent(data) {
  return new Promise((resolve) => {
    socketIoMainUser.emit("REMOVE_AMENITY_EVENT_FROM_CLIENT", data, (resp) => {
      resolve(resp);
    });
  });
}

function* sendRemoveAmenityEvent({ data }) {
  const { dataToSend, cb } = data;
  try {
    const response = yield call(ioSendRemoveAmenityEvent, dataToSend);
    const { ok, eventId, amenityId, clientReservationId } = response;

    if (cb) cb(response);

    if (ok) {
      yield put(removeAmenityEventStore({ amenityId, eventId, clientReservationId }));
    }
  } catch (error) {
    console.log(error);
    if (cb) cb({ ok: false });
  }
}

// SUPPORT CASES
function ioSendGetSupportCases() {
  return new Promise((resolve) => {
    socketIoMainUser.emit("GET_SUPPORT_CASES_FROM_CLIENT", (resp) => {
      resolve(resp);
    });
  });
}

function* sendGetSupportCases() {
  try {
    const { ok, supportCasesByClientReservation } = yield call(ioSendGetSupportCases);

    if (ok) yield put(updateAllSupportCasesStore(supportCasesByClientReservation || {}));
  } catch (error) {
    console.log(error);
  }
}

function ioSendUpdateSupportCase(data) {
  return new Promise((resolve) => {
    socketIoMainUser.emit("UPDATE_SUPPORT_CASE_FROM_CLIENT", data, (resp) => resolve(resp));
  });
}

function* sendUpdateSupportCase({ data }) {
  const { dataToSend, cb } = data;
  // console.log("sagas sendUpdateSupportCase", { dataToSend });
  try {
    const resp = yield call(ioSendUpdateSupportCase, dataToSend);
    if (resp?.ok) {
      const { supportCase } = resp;

      yield put(updateSupportCaseStore({ supportCase }));
    }
    if (cb) cb(resp);
  } catch (error) {
    console.log(error);
    if (cb) cb({ ok: false });
  }
}

function ioSendRemoveSupportCase(data) {
  return new Promise((resolve) => {
    // console.log("sagas ioSendRemoveSupportCase", { data });
    socketIoMainUser.emit("REMOVE_SUPPORT_CASE_FROM_CLIENT", data, (resp) => resolve(resp));
  });
}

function* sendRemoveSupportCase({ data }) {
  const { dataToSend, cb } = data || {};
  try {
    const resp = yield call(ioSendRemoveSupportCase, dataToSend);
    if (resp?.ok) {
      const { supportCaseId, apartmentId, clientReservationId } = resp;

      yield put(removeSupportCaseStore({ supportCaseId, apartmentId, clientReservationId }));
    }
    if (cb) cb(resp);
  } catch (error) {
    if (cb) cb({ ok: false });
    console.log(error);
  }
}

// CLIENT RESERVATIONS
// const ioSendGetClientReservations = () =>
//   new Promise((resolve) => {
//     socketIoMainUser.emit("GET_CLIENT_RESERVATIONS_FROM_CLIENT", {}, (resp) => {
//       resolve(resp);
//     });
//   });

// function* sendGetClientReservations() {
//   const resp = yield call(ioSendGetClientReservations);

//   const { ok, clientReservations } = resp;
//   // console.log("sagas respuesta de sendGetClientReservations", { resp });
//   if (ok) {
//     yield put(updateClientReservationsStore(clientReservations));
//   }
// }

const ioUpsertClientReservation = (clientReservationData) =>
  new Promise((resolve) => {
    socketIoMainUser.emit("UPSERT_CLIENT_RESERVATION", clientReservationData, (resp) =>
      resolve(resp)
    );
  });

function* sendUpsertClientReservation({ data }) {
  const { clientReservationData, cb } = data;

  try {
    const resp = yield call(ioUpsertClientReservation, clientReservationData);
    const { ok, clientReservation } = resp || {};

    if (ok && clientReservation?.uid) {
      yield call(sendGetClients);
      yield put(upsertClientReservationStore(clientReservation));
    }

    if (cb) cb(resp);
  } catch (error) {
    console.error("Error in sendUpsertClientReservation:", error);
    if (cb) cb({ ok: false, error });
  }
}

const ioRemoveClientReservation = ({ uid, clientId }) =>
  new Promise((resolve) => {
    socketIoMainUser.emit("REMOVE_CLIENT_RESERVATION", { uid, clientId }, (resp) => resolve(resp));
  });

function* sendRemoveClientReservation({ data }) {
  const { uid, clientId, cb } = data || {};

  try {
    const resp = yield call(ioRemoveClientReservation, { uid, clientId });
    const { ok, removedId } = resp || {};

    if (cb) cb(resp);
    if (ok && removedId && clientId) {
      yield put(removeClientReservationStore({ clientId, removedId }));

      yield call(sendGetClients);
      yield call(sendGetClientReservations);
      yield call(sendGetAmenityEvents);
      yield call(sendGetServiceEvents);
      yield call(sendGetSupportCases);
      yield call(getAllChatMessages);
    }
  } catch (error) {
    console.error("Error in sendRemoveClientReservation:", error);

    if (cb) cb({ ok: false, error });
  }
}

// PROJECT MANAGERS
function ioSendGetProjectManagers() {
  return new Promise((resolve) => {
    socketIoMainUser.emit("GET_PROJECT_MANAGERS_FROM_CLIENT", {}, (resp) => resolve(resp));
  });
}

function* sendGetProjectManagers() {
  try {
    const resp = yield call(ioSendGetProjectManagers);
    const { ok, projectManagers } = resp || {};
    // console.log("sagas sendGetProjectManagers", { resp });
    if (ok) {
      yield put(updateProjectManagersStore(projectManagers));
    }
  } catch (error) {
    console.log(error);
  }
}

function ioSendAddProjectManager(projectManagerData) {
  return new Promise((resolve) => {
    socketIoMainUser.emit("ADD_PROJECT_MANAGER", projectManagerData, (resp) => resolve(resp));
  });
}

function* sendAddProjectManager(action = {}) {
  const payload = action?.data && typeof action.data === "object" ? action.data : action;
  const { projectManagerData, resolve, reject } = payload;

  if (!projectManagerData) {
    if (reject) reject({ ok: false, error: "missingProjectManagerData" });
    return;
  }

  try {
    const resp = yield call(ioSendAddProjectManager, projectManagerData);
    const { ok, projectManager, projectManagerUid } = resp || {};
    const resolvedProjectManagerUid = projectManagerUid || projectManager?.uid;
    // console.log("sagas sendAddProjectManager", { projectManagerData, resp });
    if (ok && projectManager && resolvedProjectManagerUid) {
      yield put(upsertProjectManagerStore(projectManager, resolvedProjectManagerUid));
      if (resolve) resolve(resp);
      return;
    }

    if (reject) reject(resp);
  } catch (error) {
    console.log("sagas sendAddProjectManager", error);
    if (reject) reject(error);
  }
}

function ioSendUpdateProjectManager(projectManagerData) {
  return new Promise((resolve) => {
    socketIoMainUser.emit("UPDATE_PROJECT_MANAGER", projectManagerData, (resp) => resolve(resp));
  });
}

function* sendUpdateProjectManager({ projectManagerData, resolve, reject }) {
  try {
    const resp = yield call(ioSendUpdateProjectManager, projectManagerData);
    const { ok, projectManager, projectManagerUid } = resp || {};

    if (ok && projectManager && projectManagerUid) {
      yield put(upsertProjectManagerStore(projectManager, projectManagerUid));
      if (resolve) resolve(resp);
      return;
    }

    if (reject) reject(resp);
  } catch (error) {
    console.log("sagas sendUpdateProjectManager", error);
    if (reject) reject(error);
  }
}

function ioSendRemoveProjectManager(projectManagerUid) {
  return new Promise((resolve) => {
    socketIoMainUser.emit("REMOVE_PROJECT_MANAGER", { uid: projectManagerUid }, (resp) =>
      resolve(resp)
    );
  });
}

function* sendRemoveProjectManager({ projectManagerUid, resolve, reject }) {
  try {
    const resp = yield call(ioSendRemoveProjectManager, projectManagerUid);
    const { ok, removedId } = resp || {};

    if (ok && removedId) {
      yield put(removeProjectManagerStore(removedId));
      if (resolve) resolve(resp);
      return;
    }

    if (reject) reject(resp);
  } catch (error) {
    console.log("sagas sendRemoveProjectManager", error);
    if (reject) reject(error);
  }
}

// DATE TIME
function ioGetDateTime() {
  return new Promise((resolve, reject) => {
    socketIoClient.emit("GET_DATE_TIME_FROM_CLIENT", (timeData) => {
      if (timeData) {
        resolve(timeData);
      } else {
        reject();
      }
    });
  });
}

function* getDateTime({ cb }) {
  try {
    const timeData = yield call(ioGetDateTime);
    cb(timeData);
  } catch (error) {
    console.log(error);
  }
}

function ioUpdateData(updateData) {
  const { data } = updateData;
  return new Promise((resolve) => {
    socketIoClient.emit("SEND_UPDATE_APP_FROM_CLIENT", data, (success) => {
      if (success === "ok") {
        resolve();
      } else {
        resolve();
      }
    });
  });
}

function* updateApp(updateData) {
  try {
    yield call(ioUpdateData, updateData);
  } catch (error) {
    console.log(error);
  }
}

function ioSendRebootOnna() {
  return new Promise((resolve) => {
    socketIoClient.emit("SEND_REBOOT_ONNA_FROM_CLIENT", (success) => {
      if (success) {
        resolve();
      } else {
        resolve();
      }
    });
  });
}

function* sendRebootOnna() {
  try {
    yield call(ioSendRebootOnna);
  } catch (error) {
    console.log(error);
  }
}

// End

/** **********
 * SCHEDULE *
 ********** */

const ioSendNewSchedulesServer = (data) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("NEW_SCHEDULE_FROM_CLIENT", data.data.nodeId, data.data, (success) => {
      if (success) {
        resolve();
      } else {
        reject();
      }
    });
  });
// NEW Scheduler
function* sendNewScheduleServerGenerator(data) {
  try {
    yield call(ioSendNewSchedulesServer, data);
  } catch (error) {
    console.log(error);
  }
}

// EDIT Scheduler
function ioSendEditScheduleServer({ data }) {
  return new Promise((resolve, reject) => {
    socketIoClient.emit("EDIT_SCHEDULE_FROM_CLIENT", data.nodeId, data.id, data, (success) => {
      if (success) {
        resolve();
      } else {
        reject();
      }
    });
  });
}

function* sendEditScheduleServerGenerator(data) {
  try {
    yield call(ioSendEditScheduleServer, data);
  } catch (error) {
    console.log(error);
  }
}

// REMOVE Scheduler
function ioSendRemoveScheduleServer({ data }) {
  return new Promise((resolve, reject) => {
    socketIoClient.emit("REMOVE_SCHEDULE_FROM_CLIENT", data.nodeId, data.id, (success) => {
      if (success) {
        resolve();
      } else {
        reject();
      }
    });
  });
}

function* sendRemoveScheduleServerGenerator(data) {
  try {
    yield call(ioSendRemoveScheduleServer, data);
  } catch (error) {
    console.log(error);
  }
}

function ioSendEnableSchedulesServer({ data }) {
  return new Promise((resolve, reject) => {
    socketIoClient.emit("ENABLE_SCHEDULES_FROM_CLIENT", data.nodeId, data.enable, (success) => {
      if (success) {
        resolve();
      } else {
        reject();
      }
    });
  });
}

function* sendEnableSchedulesServerGenerator(data) {
  try {
    yield call(ioSendEnableSchedulesServer, data);
  } catch (error) {
    console.log(error);
  }
}

// END

/** **********
 * ALARM *
 ********** */

// ARM

function ioSendArmAlarmServer(data) {
  return new Promise((resolve, reject) => {
    socketIoClient.emit("ARM_ALARM_FROM_CLIENT", data.partial, (success) => {
      if (success) {
        resolve();
      } else {
        reject();
      }
    });
  });
}

function* sendArmAlarmServerGenerator(data) {
  try {
    yield call(ioSendArmAlarmServer, data);
  } catch (error) {
    console.log(error);
  }
}

// DISARM

function ioSendDisarmAlarmServer(data) {
  return new Promise((resolve) => {
    socketIoClient.emit("DISARM_ALARM_FROM_CLIENT", data.pin, (success) => {
      if (!success)
        store.dispatch(
          showModal({
            title: "alertTitleAlarm",
            body: "alertBodyPINWrong",
            showModal: true,
            buttons: 1,
            button1Text: "alertBtnOk",
          })
        );
      resolve();
    });
  });
}

function* sendDisarmAlarmServerGenerator(data) {
  yield call(ioSendDisarmAlarmServer, data);
}

function ioSendChangePasswordAlarmServer(data) {
  return new Promise((resolve) => {
    socketIoClient.emit("CHANGE_PASSWORD_ALARM_CLIENT", data, (success) => {
      if (success) {
        store.dispatch(
          showModal({
            title: "alertTitleInformation",
            body: "pinCodeChanged",
            showModal: true,
            buttons: 1,
            button1Text: "alertBtnOk",
          })
        );
      } else {
        store.dispatch(
          showModal({
            title: "alertTitleInformation",
            body: "pinCodeWrong",
            showModal: true,
            buttons: 1,
            button1Text: "alertBtnOk",
          })
        );
      }
      resolve();
    });
  });
}

function* sendChangePasswordAlarmServerGenerator(action) {
  const { data } = action;
  yield call(ioSendChangePasswordAlarmServer, data);
}

// END

/** **********
 * MACROS *
 ********** */

// NEW Macro

const ioSendNewMacroServer = (data) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit(
      "NEW_MACRO_FROM_CLIENT",
      data.data.roomNodeId,
      data.data.macro,
      (success) => {
        if (success) {
          resolve();
        } else {
          reject();
        }
      }
    );
  });

function* sendNewMacroServerGenerator(data) {
  try {
    yield call(ioSendNewMacroServer, data);
  } catch (error) {
    console.log(error);
  }
}

// EDIT Macro

const ioSendEditMacroServer = ({ data }) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit(
      "EDIT_MACRO_FROM_CLIENT",
      data.roomNodeId,
      data.macroId,
      data.macro,
      (success) => {
        if (success) {
          resolve();
        } else {
          reject();
        }
      }
    );
  });

function* sendEditMacroServerGenerator(data) {
  try {
    yield call(ioSendEditMacroServer, data);
  } catch (error) {
    console.log(error);
  }
}

// REMOVE Macro
const ioSendRemoveMacroServer = (data) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit(
      "REMOVE_MACRO_FROM_CLIENT",
      data.data.roomNodeId,
      data.data.macroId,
      (success) => {
        if (success) {
          resolve();
        } else {
          reject();
        }
      }
    );
  });

function* sendRemoveMacroServerGenerator(data) {
  try {
    yield call(ioSendRemoveMacroServer, data);
  } catch (error) {
    console.log(error);
  }
}

// EXECUTE Macro

const ioSendExecuteMacroServer = (data) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit(
      "EXECUTE_MACRO_FROM_CLIENT",
      data.data.roomNodeId,
      data.data.macroId,
      (success) => {
        if (success) {
          resolve();
        } else {
          reject();
        }
      }
    );
  });

function* sendExecuteMacroServerGenerator(data) {
  try {
    yield call(ioSendExecuteMacroServer, data);
  } catch (error) {
    console.log(error);
  }
}

// END

/** *********
 * SOCKET IO
 ********** */

// FIREBASE

const getSocket = (receivedData) =>
  new Promise((resolve, reject) => {
    if (socketIoClient) {
      socketIoClient.disconnect();
    }

    const {
      userId,
      onnaId,
      apartmentId,
      userName,
      clientUserId,
      token,
      isProjectManager = false,
      mainUserUid = null,
    } = receivedData;

    // console.log("getSocket", { receivedData });

    if (userId && onnaId) {
      const newSocketIo = io(`${socketPath}/${onnaId}`, {
        auth: {
          userId,
          apartmentId,
          userName,
          expoToken: null,
          onnaId,
          clientUserId,
          token,
          isProjectManager,
          mainUserUid,
        },
        forceNew: true,
      });
      newSocketIo.on("connect", () => {
        store.dispatch(actionSocketConnectionType("local"));
        store.dispatch(actionOnnaSocketStatus(true));
        resolve(newSocketIo);
      });

      newSocketIo.on("connect_error", (error) => {
        console.log(error);
      });
    } else {
      reject();
    }
  });

function* initSocketServerGenerator({ data: receivedData }) {
  try {
    const { userName, clientUserId } = receivedData;
    if (socketIoClient) {
      socketIoClient.disconnect();
      socketIoClient = null;
    }
    store.dispatch(actionOnnaSocketStatus(false));
    socketIoClient = yield call(getSocket, receivedData);
    yield call(initCalls, receivedData);
    const { id } = socketIoClient;
    const { uri } = io;

    socketIoClient.on("error", (error) => {
      console.log(error);
    });

    socketIoClient.on("NEW_CONFIGURATION_FROM_SERVER", () => {
      store.dispatch(initConfigurationServer());
    });

    socketIoClient.on("ONNA_DISCONNECTED", () => {
      store.dispatch(actionServerSocketStatus(false));
      socketIoClient.disconnect();
    });

    // yield put(actionLastIpConnection({ uri }));

    yield put(actionSocketInfo({ nameSpace: uri, socketID: id }));

    // Listen SOCKET
    socketIoClient.on("SET_ADDRESS_VALUE_FROM_SERVER", (data) => {
      store.dispatch(editAddressStore(data));
    });

    // Update schedules
    socketIoClient.on("UPDATE_SCHEDULES_FROM_SERVER", (schedules, apartmentId) => {
      if (userName === "cloud") {
        store.dispatch(updateSchedulesFromServer({ schedules, apartmentId }));
      } else {
        store.dispatch(updateSchedulesFromServer({ schedules }));
      }
    });

    // Update notifications
    socketIoClient.on("UPDATE_NOTIFICATIONS_FROM_SERVER", (notifications) => {
      if (userName === "web" && notifications) {
        store.dispatch(updateNotifications(notifications));
        let badgeNumber = 0;
        Object.values(notifications || {}).forEach((notification) => {
          if (!notification.read) badgeNumber += 1;
        });
        store.dispatch(updateBadgeNotifications(badgeNumber));
      }
    });

    // Update alarm
    socketIoClient.on("UPDATE_ALARM_FROM_SERVER", (data) => {
      store.dispatch(updateAlarmStore(data));
    });

    // Update Macros
    socketIoClient.on("UPDATE_MACROS_FROM_SERVER", (macros, apartmentId) => {
      if (userName === "cloud") {
        store.dispatch(updateMacrosFromServer({ macros, apartmentId }));
      } else {
        store.dispatch(updateMacrosFromServer({ macros }));
      }
    });

    // Intercoms

    socketIoClient.on("NEW_CALL_STATE_FROM_SERVER", (data) => {
      store.dispatch(updateIntercomsStore({ callState: data }));
    });

    socketIoClient.on("NEW_VOLUMES_FROM_SERVER", (data) => {
      store.dispatch(updateIntercomsStore(data));
    });

    // KNX Port Status
    socketIoClient.on(KNX_STATE_FROM_SERVER, (data) => {
      store.dispatch(knxState(data));
    });

    // ThermostatsIP
    socketIoClient.on("UPDATE_THERMOSTATIP_STATE_IN_REDUCER", (data) => {
      store.dispatch(updateThermostatIp(data));
    });

    // Internet State
    socketIoClient.on(INTERNET_STATE_FROM_SERVER, (data) => {
      store.dispatch(internetState(data));
    });

    socketIoClient.on("INIT_ADDRESES_FROM_SERVER", (addressesFromServer, valuesFromServer) => {
      if (addressesFromServer && valuesFromServer) {
        const addresses = [];

        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (const i in addressesFromServer) {
          addresses.push({
            ...addressesFromServer[i],
            ...valuesFromServer[i],
          });
        }
        store.dispatch(initAddressesStore(addresses));
      }
    });

    // Trends History
    socketIoClient.on(SET_TRENDS_HISTORY, (data) => {
      store.dispatch(setTrendsHistory(data));
    });

    socketIoClient.on("USER_CHECKOUT", (userId) => {
      if (userId === clientUserId) {
        store.dispatch(signOut());
      }
    });

    // Bacnet
    socketIoClient.on("UPDATE_BACNET_ADDRESSES_IN_REDUCER", (data) => {
      store.dispatch(updateBacnetAddressesStore(data));
    });

    socketIoClient.on("disconnect", () => {
      store.dispatch(actionOnnaSocketStatus(false));
      store.dispatch(actionServerSocketStatus(false));
    });
  } catch (e) {
    console.log(e);
  }
}

function* initClientGenerator({ data }) {
  try {
    const { uid, email, token, isMainUser = false, isProjectManager = false } = data;
    // console.log("initClientGenerator", { uid, email, isMainUser, isProjectManager });
    const databaseRef = ref(database);
    const snapshot = yield call(get, child(databaseRef, `clientsData/${uid}`));
    const isNotAClient = !snapshot.exists();
    // console.log("initClientGenerator", { uid, isNotAClient });
    if (isNotAClient) {
      return;
    }

    const {
      activeReservations,
      onnaId,
      mainUserId,
      projectId,
      apartmentId,
      displayName,
      isOldReservation,
    } = yield call(ioGetValidCredentials, {
      userId: uid,
    });

    // Usuario antiguo
    const hasOnlyOldStructure =
      !!isOldReservation && (!activeReservations || activeReservations.length === 0);

    if (hasOnlyOldStructure) {
      if (isMainUser || isProjectManager) {
        const state = store.getState();
        const projectsReducer = state?.projectsReducer || {};
        const apartmentsReducer = state?.apartmentsReducer || {};

        const oldProjectName = projectsReducer?.[projectId]?.name || projectId;
        const oldApartmentName = apartmentsReducer?.[apartmentId]?.name || apartmentId;

        const managerOption = {
          apartmentId: "MANAGER_MODE",
          projectName: "managerMode",
          apartmentName: "accessAsAdministrator",
        };

        const oldReservationOption = {
          uid: `${uid}-${apartmentId}`,
          apartmentId,
          mainUserId,
          projectId,
          onnaId,
          projectName: oldProjectName,
          apartmentName: oldApartmentName,
          displayName,
        };

        store.dispatch(
          openClientReservationSelector({
            reservations: [managerOption, oldReservationOption],
            pendingAuth: {
              uid,
              email,
              token,
              isMainUser,
              isProjectManager,
              displayName,
            },
          })
        );

        return;
      }

      store.dispatch(
        updateMainUser({
          uid,
          email,
          projectId,
          apartmentId,
          isClient: true,
          isValidated: true,
          displayName,
        })
      );

      if (onnaId !== "virtual") {
        yield call(initSocketServerGenerator, {
          data: {
            userId: mainUserId,
            onnaId,
            apartmentId,
            userName: "web",
            clientUserId: uid,
            token,
            mainUserUid: mainUserId,
          },
        });
        store.dispatch(updateMainUser({ apartmentId }));
      }

      historyHelper.navigate(`/client/apartment`);
      return;
    }

    // Gestor sin reservas activas
    if (
      (isMainUser || isProjectManager) &&
      (!activeReservations || activeReservations.length === 0)
    ) {
      // No hacer nada
      return;
    }

    // Solo una reserva activa
    if (activeReservations && activeReservations.length === 1) {
      if (isMainUser || isProjectManager) {
        const managerOption = {
          apartmentId: "MANAGER_MODE",
          projectName: "managerMode",
          apartmentName: "accessAsAdministrator",
        };

        store.dispatch(
          openClientReservationSelector({
            reservations: [managerOption, ...activeReservations],
            pendingAuth: {
              uid,
              email,
              token,
              isMainUser,
              isProjectManager,
              displayName,
            },
          })
        );
      } else {
        // Cliente con 1 reserva: conectar directamente
        const reservation = activeReservations[0];
        const {
          apartmentId: reservationApartmentId,
          mainUserId: reservationMainUserId,
          projectId: reservationProjectId,
          onnaId: reservationOnnaId,
          projectFeatures: reservationProjectFeatures,
          projectMetrictsConfig: reservationProjectMetrictsConfig,
          displayName: reservationDisplayName,
        } = reservation;

        store.dispatch(
          updateMainUser({
            uid,
            email,
            projectId: reservationProjectId,
            apartmentId: reservationApartmentId,
            isClient: true,
            isValidated: true,
            projectFeatures: reservationProjectFeatures,
            projectMetrictsConfig: reservationProjectMetrictsConfig,
            displayName: reservationDisplayName,
          })
        );

        if (reservationOnnaId !== "virtual") {
          yield call(initSocketServerGenerator, {
            data: {
              userId: reservationMainUserId,
              onnaId: reservationOnnaId,
              apartmentId: reservationApartmentId,
              userName: "web",
              clientUserId: uid,
              token,
              isProjectManager,
              mainUserUid: reservationMainUserId,
            },
          });
          // store.dispatch(updateMainUser({ apartmentId: reservationApartmentId }));
        }

        historyHelper.navigate(`/client/apartment`);
      }

      // Múltiples reservas activas: mostrar selector
    } else if (activeReservations && activeReservations.length > 1) {
      let reservationsToShow = activeReservations;
      if (isMainUser || isProjectManager) {
        const managerOption = {
          apartmentId: "MANAGER_MODE",
          projectName: "managerMode",
          apartmentName: "accessAsAdministrator",
        };
        reservationsToShow = [managerOption, ...activeReservations];
      }

      store.dispatch(
        openClientReservationSelector({
          reservations: reservationsToShow,
          pendingAuth: {
            uid,
            email,
            token,
            isMainUser,
            isProjectManager,
            displayName,
          },
        })
      );
    }
  } catch (error) {
    console.error("Error in initClientGenerator:", error);
  }
}

function* selectClientReservationGenerator({ data }) {
  try {
    const selectedReservation = data;
    const state = store.getState();
    const { pendingAuth } = state.mainUserReducer.clientReservationSelection;

    if (!pendingAuth || !selectedReservation) {
      return;
    }

    const { uid, email, token } = pendingAuth;
    const {
      apartmentId,
      mainUserId,
      projectId,
      onnaId,
      projectFeatures,
      projectMetrictsConfig,
      displayName: selectedReservationDisplayName,
    } = selectedReservation;

    // Gestor
    if (apartmentId === "MANAGER_MODE") {
      store.dispatch(closeClientReservationSelector());

      historyHelper.navigate("/");
      return;
    }

    // Cliente
    store.dispatch(
      updateMainUser({
        uid,
        email,
        projectId,
        apartmentId,
        isClient: true,
        isValidated: true,
        displayName: selectedReservationDisplayName,
        projectFeatures,
        projectMetrictsConfig,
      })
    );

    if (onnaId !== "virtual") {
      yield fork(initSocketServerGenerator, {
        data: {
          userId: mainUserId,
          onnaId,
          apartmentId,
          userName: "web",
          clientUserId: uid,
          token,
        },
      });
    }

    historyHelper.navigate(`/client/apartment`);

    store.dispatch(closeClientReservationSelector());
  } catch (error) {
    console.error("Error in selectClientReservationGenerator:", error);
  }
}

function ioInitMainUserSocketGenerator(data) {
  return new Promise((resolve, reject) => {
    const { uid, isProjectManager = false, mainUserUid = null } = data;

    if (!uid) {
      reject(new Error("Missing uid"));
      return;
    }

    const newSocketIoMainUser = io(`${socketPath}/global`, {
      autoConnect: false,
      auth: async (callback) => {
        try {
          const { currentUser } = getAuth();

          if (!currentUser || currentUser.uid !== uid) {
            throw new Error("Authentication error, user session changed");
          }

          const freshToken = await currentUser.getIdToken();

          callback({
            userId: uid,
            userName: "cloud",
            token: freshToken,
            isProjectManager,
            mainUserUid,
          });
        } catch (error) {
          console.error("Global socket token refresh failed", error);
          newSocketIoMainUser.disconnect();
          reject(error);
        }
      },
      forceNew: false,
    });

    newSocketIoMainUser.on("connect", () => {
      resolve(newSocketIoMainUser);
    });

    newSocketIoMainUser.on("connect_error", (error) => {
      console.error("Global socket connection failed", {
        message: error.message,
        code: error.data?.code,
      });
      reject(error);
    });

    newSocketIoMainUser.connect();
  });
}

function* initMainUserSocketGenerator({ data }) {
  const { uid, token, isProjectManager = false, mainUserUid = null, cb } = data;
  // console.log("initMainUserSocketGenerator", { uid, isProjectManager, mainUserUid });
  try {
    const newSocketIoMainUser = yield call(ioInitMainUserSocketGenerator, {
      uid,
      token,
      isProjectManager,
      mainUserUid,
    });
    socketIoMainUser = newSocketIoMainUser;

    //  console.log("initMainUserSocketGenerator connected", { uid, isProjectManager, mainUserUid });
    socketIoMainUser.on("disconnect", (reason) => {
      console.log("disconnect", reason);
    });

    socketIoMainUser.on("NEW_CHAT_MESSAGE_FROM_APARTMENT", (payload = {}) => {
      const message = payload?.message || {};
      const clientReservationId = payload?.clientReservationId || message?.clientReservationId;

      if (!clientReservationId || !message?.id) return;

      store.dispatch(addChatMessageStore({ clientReservationId, message }));
    });

    socketIoMainUser.on("CHAT_MESSAGE_DELETED_FROM_APARTMENT", (payload = {}) => {
      const message = payload?.message || {};
      const clientReservationId = payload?.clientReservationId;
      const messageId = message?.id;

      if (!clientReservationId || !messageId) return;

      store.dispatch(addChatMessageStore({ clientReservationId, message }));
    });

    socketIoMainUser.on("ADD_SERVICE_EVENT_FROM_APARTMENT", (resp) => {
      const { ok, newEvent } = resp;

      if (ok)
        store.dispatch(
          updateServiceEventStore({
            event: newEvent,
          })
        );
    });

    socketIoMainUser.on("REMOVE_SERVICE_EVENT_FROM_APARTMENT", (resp) => {
      const { ok, eventId, serviceId, clientReservationId } = resp;

      if (ok) store.dispatch(removeServiceEventStore({ serviceId, eventId, clientReservationId }));
    });

    socketIoMainUser.on("ADD_AMENITY_EVENT_FROM_APARTMENT", (resp) => {
      const { ok, newEvent } = resp;

      if (ok)
        store.dispatch(
          updateAmenityEventStore({
            event: newEvent,
          })
        );
    });

    socketIoMainUser.on("REMOVE_AMENITY_EVENT_FROM_APARTMENT", (resp) => {
      const { ok, eventId, amenityId, clientReservationId } = resp;

      if (ok) store.dispatch(removeAmenityEventStore({ amenityId, eventId, clientReservationId }));
    });

    socketIoMainUser.on("UPDATE_SUPPORT_CASE_FROM_APARTMENT", (resp) => {
      const { ok, supportCase } = resp;
      if (ok) store.dispatch(updateSupportCaseStore({ supportCase }));
    });

    socketIoMainUser.on("REMOVE_SUPPORT_CASE_FROM_APARTMENT", (resp) => {
      const { ok, supportCaseId, apartmentId, clientReservationId } = resp;
      if (ok)
        store.dispatch(removeSupportCaseStore({ supportCaseId, apartmentId, clientReservationId }));
    });

    cb?.(true);
  } catch (error) {
    console.log("initMainUserSocketGenerator error", error);
    cb?.(false);
  }
}

function* stopSocket() {
  if (socketIoClient) {
    socketIoClient.disconnect();
    socketIoClient = undefined;
  }
  yield put(initAddressesStore([]));
  yield put(initConfigurationStore([]));
  yield put(actionSettingsSaveData({}));
  yield put(saveMacrosFromServer({}));
  yield put(saveSchedulesFromServer({}));
  yield put(
    setTrends({
      trendData: [],
      trends: [],
      trendsHistory: {},
    })
  );
  yield put(knxState(false));
  yield put(internetState(false));
}

const sendGetIpAddress = () =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("GET_IP_ADDRESS", (ipAddress) => {
      if (ipAddress) {
        resolve(ipAddress);
      } else {
        reject();
      }
    });
  });

function* sendGetIpAddressGenerator() {
  try {
    const ipAddress = yield call(sendGetIpAddress);
    yield put(actionSettingsSaveData({ ipAddress }));
  } catch (error) {
    console.log(error);
  }
}

// END SocketIO

/**
 *
 * @param {userName, onnaId, token, state } data
 */

// GLOBAL ACTIONS

const ioSendGroupActionServer = ({ payload }) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("GROUP_ACTION_FROM_CLIENT", payload, (success) => {
      if (success) {
        resolve();
      } else {
        reject();
      }
    });
  });

function* sendGroupActionServerGenerator(data) {
  try {
    yield call(ioSendGroupActionServer, data);
  } catch (error) {
    console.log(error);
  }
}

const ioSendEditRoomNameServer = ({ payload }) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("EDIT_ROOM_NAME_FROM_CLIENT", payload, (success) => {
      if (success) {
        resolve();
      } else {
        reject();
      }
    });
  });

function* sendEditRoomNameServerGenerator(data) {
  try {
    yield call(ioSendEditRoomNameServer, data);
  } catch (error) {
    console.log(error);
  }
}

const ioSendEditRoomColorServer = ({ payload }) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("EDIT_ROOM_COLOR_FROM_CLIENT", payload, (success) => {
      if (success) {
        resolve();
      } else {
        reject();
      }
    });
  });

function* sendEditRoomColorServerGenerator(data) {
  try {
    yield call(ioSendEditRoomColorServer, data);
  } catch (error) {
    console.log(error);
  }
}

const ioSendEditDeviceNameServer = ({ payload }) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("EDIT_DEVICE_NAME_FROM_CLIENT", payload, (success) => {
      if (success) {
        resolve();
      } else {
        reject();
      }
    });
  });

function* sendEditDeviceNameServerGenerator(data) {
  try {
    yield call(ioSendEditDeviceNameServer, data);
  } catch (error) {
    console.log(error);
  }
}

const ioSendBuzzerClick = () =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("ONNA_BUZZER_CLICK", (success) => {
      if (success) {
        resolve();
      } else {
        reject();
      }
    });
  });

function* sendBuzzerClickGenerator() {
  try {
    yield call(ioSendBuzzerClick);
  } catch (error) {
    console.log(error);
  }
}

const ioChangeOpenState = (state) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("ONNA_CHANGE_OPEN_STATE", state, (success) => {
      if (success) {
        resolve(state);
      } else {
        reject();
      }
    });
  });

function* sendChangeOpenStateGenerator(state) {
  try {
    const { data } = state;
    const newState = yield call(ioChangeOpenState, data);
    yield put(actionSettingsSaveData({ openState: newState }));
  } catch (error) {
    console.log(error);
  }
}

const ioRemoveUserList = (user) =>
  new Promise((resolve) => {
    socketIoClient.emit("ONNA_REMOVE_USER_LIST", user);
    resolve();
  });

function* sendRemoveUserList(data) {
  const { user } = data;
  try {
    yield call(ioRemoveUserList, user);
  } catch (error) {
    console.log(error);
  }
}

const ioProtectSettingsPage = (data) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("PROTECT_SETTINGS_PAGE_FROM_CLIENT", data, (success) => {
      if (!success) {
        store.dispatch(
          showModal({
            title: "alertTitleInformation",
            body: "alertBodyPINWrong",
            showModal: true,
            buttons: 1,
            button1Text: "alertBtnOk",
          })
        );
        reject();
      }
      resolve();
    });
  });

function* sendProtectSettingsPage({ protectSettingsPage, pin }) {
  try {
    yield call(ioProtectSettingsPage, { protectSettingsPage, pin });
    yield put(actionSettingsSaveData({ protectSettingsPage }));
  } catch (error) {
    console.log(error);
  }
}

const ioSendNavigatePermission = (pin) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("ASK_NAVIGATE_PERMISSION_FROM_CLIENT", pin, (success) => {
      if (!success) {
        store.dispatch(
          showModal({
            title: "alertTitleInformation",
            body: "alertBodyPINWrong",
            showModal: true,
            buttons: 1,
            button1Text: "alertBtnOk",
          })
        );
        reject();
      }
      resolve();
    });
  });

function* sendNavigatePermission({ pin, url }) {
  try {
    yield call(ioSendNavigatePermission, pin);
    history.push(url);
  } catch (error) {
    console.log(error);
  }
}

const ioSendNewCallStateServer = ({ data }) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("NEW_CALL_STATE_FROM_CLIENT", data, (success) => {
      if (success) {
        resolve();
      } else {
        reject();
      }
    });
  });

function* sendNewCallStateServerGenerator(data) {
  try {
    yield call(ioSendNewCallStateServer, data);
  } catch (error) {
    console.log(error);
  }
}

const ioSendNewVolumesServer = ({ data }) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("NEW_VOLUME_VALUES_FROM_CLIENT", data, (success) => {
      if (success) {
        resolve(data);
      } else {
        reject();
      }
    });
  });

function* sendNewVolumesServerGenerator(data) {
  try {
    yield call(ioSendNewVolumesServer, data);
  } catch (error) {
    console.log(error);
  }
}

const ioSendTestAudioServer = () =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("TEST_AUDIO_FROM_CLIENT", (success) => {
      if (success) {
        resolve();
      } else {
        reject();
      }
    });
  });

function* sendTestAudioServerGenerator() {
  try {
    yield call(ioSendTestAudioServer);
  } catch (error) {
    console.log(error);
  }
}

const ioSendNewFavouritesServer = ({ data }) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("NEW_FAVOURITES_FROM_CLIENT", data, (success) => {
      if (success) {
        resolve();
      } else {
        reject();
      }
    });
  });

function* sendNewFavouritesGenerator(data) {
  try {
    yield call(ioSendNewFavouritesServer, data);
  } catch (error) {
    console.log(error);
  }
}

const ioSendGetTrendDataServer = ({ data }) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("GET_TREND_DATA", data, (requestedInfo) => {
      if (requestedInfo) {
        resolve(requestedInfo);
      } else {
        reject();
      }
    });
  });

function* sendGetTrendDataGenerator(data) {
  try {
    const trendData = yield call(ioSendGetTrendDataServer, data);
    yield put(setTrendData(trendData));
  } catch (error) {
    console.log(error);
  }
}

const ioSendGetTrendDataXlsxServer = (data) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("GET_TREND_DATA_XLSX", data, (requestedInfo) => {
      if (requestedInfo) {
        resolve(requestedInfo);
      } else {
        reject();
      }
    });
  });

function* sendGetTrendDataXlsxGenerator(request) {
  try {
    const { data } = request;
    const { startDate, endDate, address } = data;
    const response = yield call(ioSendGetTrendDataXlsxServer, data);
    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    a.download = `${startDate}_${endDate}_${address}.xlsx`;
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.log(error);
  }
}

const ioChangeThermostatValue = (data) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("UPDATE_THERMOSTATIP_PROPERTY_BY_USER", data, (success) => {
      if (success) {
        resolve();
      } else {
        reject();
      }
    });
  });

function* changeThermostatValue({ data }) {
  try {
    yield call(ioChangeThermostatValue, data);
  } catch (error) {
    console.log(error);
  }
}

const ioSendStoreTrendHistory = ({ address, lastDay, lastMonth }) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("STORE_TREND_HISTORY", { address, lastDay, lastMonth }, (response) => {
      if (response) {
        resolve(response);
      } else {
        reject();
      }
    });
  });

function* sendStoreTrendHistory(request) {
  try {
    const { data } = request;
    const { cb } = data;
    const response = yield call(ioSendStoreTrendHistory, data);
    cb(response);
  } catch (error) {
    console.log(error);
  }
}

const ioSendRemoveTrendData = (device) =>
  new Promise((resolve, reject) => {
    socketIoClient.emit("REMOVE_TREND_DATA", device, (response) => {
      if (response) {
        resolve(response);
      } else {
        reject();
      }
    });
  });

function* sendRemoveTrendData(request) {
  try {
    const { data } = request;
    const { device, cb } = data;
    const response = yield call(ioSendRemoveTrendData, device);
    if (response) yield put(setTrendData([]));
    cb(response);
  } catch (error) {
    console.log(error);
  }
}

function ioSendSendReadNotificationServer(data) {
  return new Promise((resolve, reject) => {
    const isClient = store.getState()?.mainUserReducer?.isClient || false;

    if (isClient) {
      const { id, apartmentId } = data;

      socketIoClient.emit("READ_NOTIFICATION_FROM_CLIENT", id, apartmentId, (success) => {
        if (success) {
          resolve();
        } else {
          reject();
        }
      });
    } else {
      socketIoMainUser.emit("READ_NOTIFICATION_FROM_MAINUSER", data, (success) => {
        if (success) {
          resolve();
        } else {
          reject();
        }
      });
    }
  });
}

function* sendReadNotificationServerGenerator(data) {
  try {
    yield call(ioSendSendReadNotificationServer, data);
  } catch (error) {
    console.log(error);
  }
}

function ioSendRemoveNotificationServer(data) {
  return new Promise((resolve, reject) => {
    const isClient = store.getState()?.mainUserReducer?.isClient || false;

    if (isClient) {
      const { id, apartmentId } = data;

      socketIoClient.emit("REMOVE_NOTIFICATION_FROM_CLIENT", id, apartmentId, (success) => {
        if (success) {
          resolve();
        } else {
          reject();
        }
      });
    } else {
      socketIoMainUser.emit("REMOVE_NOTIFICATION_FROM_MAINUSER", data, (success) => {
        if (success) {
          resolve();
        } else {
          reject();
        }
      });
    }
  });
}

function* sendRemoveNotificationServerGenerator(data) {
  try {
    yield call(ioSendRemoveNotificationServer, data);
  } catch (error) {
    console.log(error);
  }
}

const ioSendMakeQueryCloud = (payload) =>
  new Promise((resolve) => {
    socketIoMainUser.emit("MAKE_QUERY", payload, (resp) => {
      // console.log(resp);
      resolve(resp);
    });
  });

const ioSendMakeQueryDev = (payload) =>
  new Promise((resolve) => {
    socketIoClient.emit("MAKE_QUERY", payload, (resp) => {
      // console.log(resp);
      resolve(resp);
    });
  });

function* sendMakeQuery({ payload }) {
  try {
    const { cb, ...rest } = payload;
    const source = rest?.source.toLowerCase();
    // const flux = rest?.flux;
    // console.log({ flux });
    const response =
      source === "dev"
        ? yield call(ioSendMakeQueryDev, rest)
        : yield call(ioSendMakeQueryCloud, rest);
    // console.log({ response });
    cb(response);
  } catch (error) {
    console.log(error);
  }
}

const ioSendUpdateMainUserEmail = (emailData) =>
  new Promise((resolve) => {
    socketIoMainUser.emit("UPDATE_MAIN_USER_EMAIL", emailData, (resp) => {
      resolve(resp);
    });
  });

function* sendUpdateMainUserEmailGenerator({ data }) {
  try {
    const resp = yield call(ioSendUpdateMainUserEmail, data);
    const { success, message } = resp;
    if (!success) {
      store.dispatch(
        newAlertMessage({
          type: "error",
          title: "user",
          content: message,
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
}

// END

function* mainLoop() {
  // GLOBAL SOCKET

  yield takeEvery(GET_ONNA_DEVICES_STATE, sendGetOnnaDevicesState);
  yield takeEvery(ADD_ONNA_DEVICE_TO_PROJECT, sendAddOnnaDeviceToProject);
  yield takeEvery(REMOVE_ONNA_DEVICES_FROM_PROJECT, sendRemoveOnnaDevicesFromProject);
  yield takeEvery(CREATE_MAIN_USER, sendCreateMainUser);
  yield takeEvery(UPLOAD_MAIN_USER_IMAGE, uploadMainUserImage);
  yield takeEvery(DELETE_MAIN_USER_IMAGE, deleteMainUserImage);
  yield takeEvery(UPLOAD_PROJECT_IMAGE, uploadProjectImage);
  yield takeEvery(DELETE_PROJECT_IMAGE, deleteProjectImage);
  yield takeEvery(CHECK_CAPTCHA, sendCheckCaptcha);

  yield takeEvery(ACCESS_CONTROL_CHECK_CREDENTIALS, sendAccessControlCheckCredentials);
  yield takeEvery(ACCESS_CONTROL_GET_LOCKS, sendAccessControlGetLocks);
  yield takeEvery(ACCESS_CONTROL_GET_LOCK_PASSWORDS, sendAccessControlGetLockPasswords);
  yield takeEvery(ACCESS_CONTROL_REMOVE_LOCK_PASSWORD, sendAccessControlRemoveLockPassword);
  yield takeEvery(ACCESS_CONTROL_GET_LOCK_DETAIL, sendAccessControlGetLockDetail);
  yield takeEvery(ACCESS_CONTROL_LOCK_UNLOCK, sendAccessControlLockUnlock);
  yield takeEvery(ACCESS_CONTROL_GET_LOCK_DETAIL_CLIENT, sendAccessControlGetLockDetailClient);
  yield takeEvery(ACCESS_CONTROL_LOCK_UNLOCK_CLIENT, sendAccessControlLockUnlockClient);
  yield takeEvery(ACCESS_CONTROL_CREATE_PASSWORD, sendAccessControlCreatePassword);

  yield takeEvery(GET_OCCUPANCY_DATA, sendGetOccupancyData);
  yield takeEvery(GET_OCCUPANCY_DATA_XLSX, sendGetOccupancyDataXlsxGenerator);
  yield takeEvery(MAKE_QUERY, sendMakeQuery);

  yield takeEvery(UPDATE_MAIN_USER_EMAIL, sendUpdateMainUserEmailGenerator);

  // CLIENT SOCKET
  yield takeEvery(INIT_SOCKET, initSocketServerGenerator);
  yield takeEvery(INIT_CLIENT, initClientGenerator);
  yield takeEvery(SELECT_CLIENT_RESERVATION, selectClientReservationGenerator);
  yield takeEvery(INIT_MAIN_USER_SOCKET, initMainUserSocketGenerator);

  yield takeEvery(SEND_VALUE_SERVER, sendValueServerGenerator);
  yield takeEvery(END_SOCKET, stopSocket);
  yield takeEvery(GET_TREND_DATA, sendGetTrendDataGenerator);
  yield takeEvery(GET_TREND_DATA_XLSX, sendGetTrendDataXlsxGenerator);
  yield takeEvery(STORE_TREND_HISTORY, sendStoreTrendHistory);
  yield takeEvery(REMOVE_TREND_DATA, sendRemoveTrendData);

  yield takeEvery(UPDATE_APP, updateApp);

  // MACRO
  yield takeEvery(SEND_NEW_MACRO_SERVER, sendNewMacroServerGenerator);
  yield takeEvery(SEND_EDIT_MACRO_SERVER, sendEditMacroServerGenerator);
  yield takeEvery(SEND_REMOVE_MACRO_SERVER, sendRemoveMacroServerGenerator);
  yield takeEvery(SEND_EXECUTE_MACRO_SERVER, sendExecuteMacroServerGenerator);

  // SCHEDULE
  yield takeEvery(SEND_NEW_SCHEDULE_SERVER, sendNewScheduleServerGenerator);
  yield takeEvery(SEND_EDIT_SCHEDULE_SERVER, sendEditScheduleServerGenerator);
  yield takeEvery(SEND_REMOVE_SCHEDULE_SERVER, sendRemoveScheduleServerGenerator);
  yield takeEvery(SEND_ENABLE_SCHEDULES_SERVER, sendEnableSchedulesServerGenerator);

  yield takeEvery(SEND_READ_NOTIFICATION_SERVER, sendReadNotificationServerGenerator);

  yield takeEvery(SEND_REMOVE_NOTIFICATION_SERVER, sendRemoveNotificationServerGenerator);

  yield takeEvery(GET_DATE_TIME, getDateTime);

  yield takeEvery(SETTINGS_SEND_DATA, sendSettingsData);

  // CLIENTS RESERVATIONS
  // yield takeEvery(UPDATE_CLIENT_RESERVATIONS_BY_CLIENT_ID, sendGetClientReservationsByClientId);
  yield takeEvery(UPDATE_CLIENT_RESERVATIONS, sendGetClientReservations);
  yield takeEvery(UPSERT_CLIENT_RESERVATION, sendUpsertClientReservation);
  yield takeEvery(REMOVE_CLIENT_RESERVATION, sendRemoveClientReservation);

  // CLIENTS
  yield takeEvery(UPDATE_CLIENTS, sendGetClients);
  yield takeEvery(UPSERT_CLIENT, sendUpsertClient);
  yield takeEvery(REMOVE_CLIENT, sendRemoveClient);

  // CHAT
  yield takeEvery(GET_ALL_CHAT_MESSAGES, getAllChatMessages);
  yield takeEvery(SEND_CHAT_MESSAGE, sendChatMessage);
  yield takeEvery(SEND_CHAT_READ_EVENT, sendChatReadEvent);
  yield takeEvery(DELETE_CHAT_MESSAGE, deleteChatMessage);

  // THERMOSTATSIP
  yield takeEvery(CHANGE_THERMOSTATIP_VALUE, changeThermostatValue);

  // SERVICES
  yield takeEvery(GET_ALL_SERVICES, sendGetServices);
  yield takeEvery(UPDATE_SERVICE, sendUpdateService);
  yield takeEvery(REMOVE_SERVICES, sendRemoveServices);

  // SERVICES CATEGORIES
  yield takeEvery(GET_ALL_SERVICE_CATEGORIES, sendGetServiceCategories);
  yield takeEvery(UPDATE_SERVICE_CATEGORY, sendUpdateServiceCategory);
  yield takeEvery(REMOVE_SERVICE_CATEGORIES, sendRemoveServiceCategories);

  // SERVICES EVENTS
  yield takeEvery(GET_SERVICE_EVENTS, sendGetServiceEvents);
  yield takeEvery(UPDATE_SERVICE_EVENT, sendUpdateServiceEvent);
  yield takeEvery(REMOVE_SERVICE_EVENT, sendRemoveServiceEvent);

  // AMENITIES
  yield takeEvery(GET_ALL_AMENTIES, sendGetAmenities);
  yield takeEvery(UPDATE_AMENITY, sendUpdateAmenity);
  yield takeEvery(REMOVE_AMENTIES, sendRemoveAmenities);

  // AMENITY EVENTS
  yield takeEvery(GET_AMENITY_EVENTS, sendGetAmenityEvents);
  yield takeEvery(UPDATE_AMENITY_EVENT, sendUpdateAmenityEvent);
  yield takeEvery(REMOVE_AMENITY_EVENT, sendRemoveAmenityEvent);

  // SUPPORT CASES
  yield takeEvery(GET_ALL_SUPPORT_CASES, sendGetSupportCases);
  yield takeEvery(UPDATE_SUPPORT_CASE, sendUpdateSupportCase);
  yield takeEvery(REMOVE_SUPPORT_CASE, sendRemoveSupportCase);

  // PROJECT MANAGERS
  yield takeEvery(SEND_GET_PROJECT_MANAGERS, sendGetProjectManagers);
  yield takeEvery(SEND_ADD_PROJECT_MANAGER, sendAddProjectManager);
  yield takeEvery(SEND_EDIT_PROJECT_MANAGER, sendUpdateProjectManager);
  yield takeEvery(SEND_REMOVE_PROJECT_MANAGER, sendRemoveProjectManager);
  yield takeEvery(SEND_METRICS_LIMITS_BY_PROJECT, sendMetricsLimitsByProject);

  while (false) {
    if (!appStarted) {
      appStarted = true;
    }
    // To be able to restart every rerender while testing

    yield takeEvery(INIT_CONFIGURATION_SERVER, initCalls);

    yield takeEvery(REBOOT_ONNA, sendRebootOnna);

    // END

    // ALARM
    yield takeEvery(SEND_ARM_ALARM_SERVER, sendArmAlarmServerGenerator);
    yield takeEvery(SEND_DISARM_ALARM_SERVER, sendDisarmAlarmServerGenerator);
    yield takeEvery(SEND_CHANGE_PASSWORD_ALARM_SERVER, sendChangePasswordAlarmServerGenerator);

    // END

    // GLOBAL ACTIONS
    yield takeEvery(GET_IP_ADDRESS, sendGetIpAddressGenerator);

    yield takeEvery(SEND_GROUP_ACTION_SERVER, sendGroupActionServerGenerator);

    yield takeEvery(SEND_EDIT_ROOM_NAME_SERVER, sendEditRoomNameServerGenerator);
    yield takeEvery(SEND_EDIT_ROOM_COLOR_SERVER, sendEditRoomColorServerGenerator);
    yield takeEvery(SEND_EDIT_DEVICE_NAME_SERVER, sendEditDeviceNameServerGenerator);
    yield takeEvery(SEND_BUZZER_CLICK_SERVER, sendBuzzerClickGenerator);

    yield takeEvery(SEND_CHANGE_OPEN_STATE, sendChangeOpenStateGenerator);
    yield takeEvery(SEND_REMOVE_USER_LIST, sendRemoveUserList);

    yield takeEvery(SEND_PROTECT_SETTINGS_PAGE, sendProtectSettingsPage);
    yield takeEvery(ASK_NAVIGATE_PERMISSION, sendNavigatePermission);

    // END

    // INTERCOMS
    yield takeEvery(SEND_NEW_CALL_STATE_SERVER, sendNewCallStateServerGenerator);
    yield takeEvery(SEND_NEW_VOLUMES_SERVER, sendNewVolumesServerGenerator);

    yield takeEvery(SEND_TEST_AUDIO_SERVER, sendTestAudioServerGenerator);

    yield takeEvery(SEND_NEW_FAVOURITES_SERVER, sendNewFavouritesGenerator);

    // TRENDS

    // END
  }
}

export default function* primaryFunction() {
  yield fork(mainLoop);
}
